// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.suggestion-box-lite {
  margin-top: 0.5rem;
  padding: 1.5rem;
  border: 1px solid #edf0f4;
  border-radius: 14px;
  background: #fafbfc;
}

.suggestion-box-lite-heading {
  margin-bottom: 1rem;
}

.suggestion-box-lite-heading h2 {
  margin: 0.2rem 0 0.3rem;
  font-size: 1.25rem;
  color: #202124;
}

.suggestion-box-lite-heading p:last-child {
  margin: 0;
  font-size: 0.9rem;
  color: #747b84;
}

/* .suggestion-box-lite-fields {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.7rem;
  margin-bottom: 0.7rem;
} */

.suggestion-box-lite-fields {
  display: flex;
  flex-direction: column;
  gap: 0.7rem;
  margin-bottom: 0.7rem;
}

.suggestion-box-lite input,
.suggestion-box-lite textarea {
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #e1e5ea;
  border-radius: 8px;
  background: #fff;
  color: #333;
  font: inherit;
  font-size: 0.9rem;
  outline: none;
}

.suggestion-box-lite input {
  height: 40px;
  padding: 0 0.75rem;
}

.suggestion-box-lite textarea {
  display: block;
  min-height: 90px;
  padding: 0.7rem 0.75rem;
  resize: vertical;
}

.suggestion-box-lite input::placeholder,
.suggestion-box-lite textarea::placeholder {
  color: #a5abb3;
}

.suggestion-box-lite input:focus,
.suggestion-box-lite textarea:focus {
  border-color: #b8c9e8;
  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.06);
}

.suggestion-box-lite-action {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 0.75rem;
  margin-top: 0.7rem;
}

.suggestion-box-lite-action button {
  padding: 0.5rem 1rem;
  border: 0;
  border-radius: 7px;
  background: #2563eb;
  color: #fff;
  font-size: 0.85rem;
  cursor: pointer;
}

.suggestion-box-lite-action button:hover:not(:disabled) {
  background: #1d4ed8;
}

.suggestion-box-lite-action button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.suggestion-box-lite-feedback {
  margin-right: auto;
  font-size: 0.8rem;
}

.suggestion-box-lite-feedback.sent {
  color: #16803c;
}

.suggestion-box-lite-feedback.error {
  color: #c62828;
}

@media (max-width: 600px) {
  .suggestion-box-lite {
    padding: 1.2rem;
  }

  .suggestion-box-lite-fields {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/suggestionBoxLite/suggestionBoxLite.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;;;;GAKG;;AAEH;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,qBAAqB;AACvB;;AAEA;;EAEE,WAAW;EACX,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".suggestion-box-lite {\n  margin-top: 0.5rem;\n  padding: 1.5rem;\n  border: 1px solid #edf0f4;\n  border-radius: 14px;\n  background: #fafbfc;\n}\n\n.suggestion-box-lite-heading {\n  margin-bottom: 1rem;\n}\n\n.suggestion-box-lite-heading h2 {\n  margin: 0.2rem 0 0.3rem;\n  font-size: 1.25rem;\n  color: #202124;\n}\n\n.suggestion-box-lite-heading p:last-child {\n  margin: 0;\n  font-size: 0.9rem;\n  color: #747b84;\n}\n\n/* .suggestion-box-lite-fields {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 0.7rem;\n  margin-bottom: 0.7rem;\n} */\n\n.suggestion-box-lite-fields {\n  display: flex;\n  flex-direction: column;\n  gap: 0.7rem;\n  margin-bottom: 0.7rem;\n}\n\n.suggestion-box-lite input,\n.suggestion-box-lite textarea {\n  width: 100%;\n  box-sizing: border-box;\n  border: 1px solid #e1e5ea;\n  border-radius: 8px;\n  background: #fff;\n  color: #333;\n  font: inherit;\n  font-size: 0.9rem;\n  outline: none;\n}\n\n.suggestion-box-lite input {\n  height: 40px;\n  padding: 0 0.75rem;\n}\n\n.suggestion-box-lite textarea {\n  display: block;\n  min-height: 90px;\n  padding: 0.7rem 0.75rem;\n  resize: vertical;\n}\n\n.suggestion-box-lite input::placeholder,\n.suggestion-box-lite textarea::placeholder {\n  color: #a5abb3;\n}\n\n.suggestion-box-lite input:focus,\n.suggestion-box-lite textarea:focus {\n  border-color: #b8c9e8;\n  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.06);\n}\n\n.suggestion-box-lite-action {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 0.75rem;\n  margin-top: 0.7rem;\n}\n\n.suggestion-box-lite-action button {\n  padding: 0.5rem 1rem;\n  border: 0;\n  border-radius: 7px;\n  background: #2563eb;\n  color: #fff;\n  font-size: 0.85rem;\n  cursor: pointer;\n}\n\n.suggestion-box-lite-action button:hover:not(:disabled) {\n  background: #1d4ed8;\n}\n\n.suggestion-box-lite-action button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.suggestion-box-lite-feedback {\n  margin-right: auto;\n  font-size: 0.8rem;\n}\n\n.suggestion-box-lite-feedback.sent {\n  color: #16803c;\n}\n\n.suggestion-box-lite-feedback.error {\n  color: #c62828;\n}\n\n@media (max-width: 600px) {\n  .suggestion-box-lite {\n    padding: 1.2rem;\n  }\n\n  .suggestion-box-lite-fields {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
